import { render, staticRenderFns } from "./SocialTable.vue?vue&type=template&id=510e3be5&"
import script from "./SocialTable.vue?vue&type=script&lang=js&"
export * from "./SocialTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports